<template>
  <div class="casemainBox">
    <p class="title">{{nowCaseItem.typename}}</p>
    <div class="caseBox 1">
      <div class="top">
        <ul class="left">
          <li>
            <div class="yuan">{{keyIndex + 1}}</div>
          </li>
          <li><b>{{nowCaseItem.name}}</b></li>
          <li>{{nowCaseItem.contact}}</li>
          <li>【{{languageIndex == 0 ? nowCaseItem.typename : nowCaseItem.typenameEn}}】</li>
          <li>案件号：{{nowCaseItem.caseNo}}</li>
        </ul>
        <ul class="right">
          <li class="text1">{{stasusFun(nowCaseItem.caseState,nowCaseItem.solutionState)}}</li>
          <!--<li class="text1">{{nowCaseItem.caseState}}</li>-->
          <!-- <li v-if="nowCaseItem.typeId == 600 && $route.name == 'mainPaseCmdcenter'"></li> -->
          <li><a class="btn" @click="lookinf(nowCaseItem.typeId,nowCaseItem.caseState,nowCaseItem.solutionState,nowCaseItem.id,nowCaseItem.subRegulatorId,nowCaseItem.regulatorId)" v-html="btnText==1?langtrans().czkkbb[languageIndex]:langtrans().czkk[languageIndex]"></a></li>
        </ul>
      </div>
      <div class="moreCase">
        <ul>
          <li :class="{redBack:item.caseState == 110 || item.caseState == 111,active:activeIndex == index}" v-for="(item,index) in nowCaseItemList" @click="activeObjFun(index)" :title="item.typename">{{item.typename}} {{item.caseState == 110 ? '(完)':''}} {{ item.caseState == 111 ? '(关)':''}}</li>
        </ul>
      </div>
      <process v-show="nowCaseItem.typeId != 600" :serviceLst='nowCaseItem.serviceLst' :serviceIndex='nowCaseItem.serviceIndex' :caseState='nowCaseItem.caseState'></process>
      <li v-if="nowCaseItem.typeId == 600" style="margin-top: 10px;height: 2px;"></li>
      <table width="100%" border="0" class="table1">
        <thead>
          <tr>
            <th width="22.5%">{{langtrans().sjj[languageIndex]}}</th>
            <th width="22.5%" v-if="nowCaseItem.typeId != 900">{{langtrans().cczzzf[languageIndex]}}</th>
          
            <th width="22.5%" v-else>{{langtrans().cczzfff[languageIndex]}}</th>
            <th width="22.5%" >{{langtrans().cczzzj[languageIndex]}}</th>
           
            <th width="22.5%">{{langtrans().cczzzx[languageIndex]}}</th>
            <th width="10%">{{langtrans().zt[languageIndex]}}</th>
          </tr>
        </thead>
      </table>
      <div class="tableBox">
        <div class="table innerbox">
          <table width="100%" border="0" cellpadding="0" cellspacing="0">
            <tbody>
              <tr v-for="item in nowCaseItem.tableData">
                <!-- {{ nowCaseItem.tableData }} -->
                <td width="22.5%">
                  {{item.time}}
                </td>
                <td width="22.5%">{{item.oper}}</td>
                <td width="22.5%">{{languageIndex == 0 ? setTxt(item.node,'zh'): setTxt(item.node,'en')}}</td>
                <td width="22.5%">{{item.detail}}</td>
                <td width="10%">{{item.nstate}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


    </div>
    <div class="btnWorkbench">
      <p class="text2">{{langtrans().ajyhs[languageIndex]}} <span>{{nowCaseItem.alltime}}</span></p>
    </div>
    <!-- <workbench v-show='workbenchShow' ref=workIm :nowCaseItem=nowCaseItem></workbench> -->
    <el-dialog title="关联案件" :visible.sync="centerDialogVisible1" center width="650px" :modal-append-to-body='false'>
      <ul class="aboutCase">
        <li v-if="tableData.length != 0" v-for="item in tableData">
          <span>案件编号：{{item.caseNo}}</span>
          <!-- <i class="el-icon-arrow-right"></i> -->
        </li>
        <li v-if="tableData.length == 0" style="text-align: center;color: #999;">
          暂无关联案件
        </li>
      </ul>
    </el-dialog>
     <el-dialog title="添加回访" :visible.sync="centerDialogVisible2" center width="850px" :modal-append-to-body='false'>
       <div class="jianbao">
            <div>
              <span>回访内容：</span>
              <el-input style='width: 600px;' placeholder="请填写内容" v-model='jbTitle'></el-input>
            </div>
            <!-- <div>
              <span>详细内容：</span>
              <el-input style='width: 600px;' type="textarea" placeholder="请填写详细内容" v-model='uploadIdText'></el-input>
            </div>
            <div>
              <span>通话录音：</span>
              <el-select v-model="valueSelect" placeholder="请选择" style="width: 600px;">
              <el-option
                v-for="(item,index) in pstnCallLstList"
                :key="item.index"
                :label="item.name"
                :value="item.ucnt.id">
              </el-option>
            </el-select>
            </div> -->
       </div>
          <el-button class='popBtn' type="primary" @click='addbrief'>确定</el-button>
    </el-dialog>
      <el-dialog title="添加外部录音" :visible.sync="centerDialogVisible3" center width="650px" :modal-append-to-body='false'>
       <div class="jianbao">
            <div>
              <span>标题：</span>
              <el-input style='width: 400px;' placeholder="请填写标题" v-model='description'></el-input>
            </div>
            <div>
              <span>主叫：</span>
              <el-input style='width: 400px;' placeholder="请填写主叫" v-model='descriptionFrom'></el-input>
            </div>
             <div>
              <span>被叫：</span>
              <el-input style='width: 400px;' placeholder="请填写被叫" v-model='descriptionTo'></el-input>
            </div>
            <div class="fujian">
              <span>附件：</span>
              <div style="display: inline-block;">
                 <el-upload class="upload-demo"
                action="aaa"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="5"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
                :http-request="requestFile"
                 >
                  <el-button size="small" type="primary":loading="uploadBtn">点击添加</el-button>
                  <div slot="tip" class="el-upload__tip">可上传5个附件，每个附件大小不得超过8M</div>

                </el-upload>
              </div>

            </div>
       </div>
          <el-button class='popBtn' type="primary" @click='uploadFileFun'>确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import langtrans from "./js/case.vue.trans.js";
  import process from '@/components/process'
  import constants from '@/util/constants.js';
  import { connectedCaseList,addbrief,uploadFile,noticeAccessCaseLiability,userlist_regulator } from '@/views/axios/api.js';
  import axios from 'axios'
  export default {
    data() {
      return {
        valueSelect: '',
        token:JSON.parse(window.localStorage.getItem('data')).data,
        insti:JSON.parse(window.localStorage.getItem("insti")),//头部数据
        status: [ //救援机构
          '等待方案报价',
          '等待授权中',
          '救援中案件',
          '案件已完成'
        ],
        statusEn: [ //救援机构
          'Waiting for proposal quotation',
          'Waiting for the authorization',
          'Assistance case in progress',
          'Case Complete'
        ],
        status1: [
          '等待授权启动',
          '等待方案报价中',
          '救援中案件管理',
          '已完成救援案件'
        ],
        status2: [
          '未启动救援',
          '等待启动授权',
          '启动授权通过，待转交救援机构报价',
          '等待救援公司报价中',
          '已转交报价，等待监管授权',
          '报价授权通过，请开始救援',
          '开始救援中',
          '救援完成待确认',
          '救援完成',
          '分公司拒绝派单',//形式
          '总司调处拒绝派单',
          '等待分公司调处确认',
          '等待总公司调处确认',
          '进入正常流程，等待海外代表接入，或直接接单等后续流程'
        ],
        status3:[
          '分公司拒绝派单',//形式
          '总司调处拒绝派单',
          '等待分公司调处确认',
          '等待总公司调处确认',
          '进入正常流程，等待海外代表接入，或直接接单等后续流程',
          '已完成'
        ],
        centerDialogVisible1: false,
        centerDialogVisible2: false,
        centerDialogVisible3: false,
        tableData: [],
        uploadIdText:'1',
        jbTitle:'',
        fileList:[],
        uploadBtn:false,
        fileUrl:[],
        description:'录音',
        descriptionFrom:'',
        descriptionTo:'',
        nowCaseItem:{},
        activeIndex:0,
        detailsId:''
      }
    },
    components: {
      process
    },
    mounted() {
      this.$nextTick( () => {
        console.log(this.nowCaseItemList[0])
        this.nowCaseItem=this.nowCaseItemList[0];
        this.detailsId=this.nowCaseItemList[0].id
      })
    },
    props: [
      'nowCaseItemList',
      'btnText',
      'keyIndex',
      'routerName',
      'pstnCallLstList'
    ],
    computed: {
      languageIndex() {
        return this.$store.state.language
      }
    },
    methods: {
      activeObjFun(index){
        this.activeIndex = index;
        this.nowCaseItem=this.nowCaseItemList[index];
      },
      langtrans() {
        return langtrans
      },
      setTxt(str, status) {
        if (constants.setTxt(str, status)) {
          return constants.setTxt(str, status)
        } else {
          return str
        }
      },
      stasusFun(str, solutionState) {
        var status = ''
        if (this.$route.name == 'mainPase') {//救援机构
          if (this.languageIndex == 0) {
            if (str == '180') {
              status = this.status[2]
            } else if ((str == 140 && solutionState != 0) || str == 150 || str == 160) {
              status = this.status[1]
            } else if (str == '110') {
              status = this.status[3]
            } else {
              status = this.status[0]
            }
          } else {
            if (str == '180') {
              status = this.statusEn[2]
            } else if ((str == 140 && solutionState != 0) || str == 150 || str == 160) {
              status = this.statusEn[1]
            } else if (str == '110') {
              status = this.statusEn[3]
            } else {
              status = this.statusEn[0]
            }
          }

        } else if (this.$route.name == 'mainPaseRegulator') { //监管机构
          if (str == 120) {
            status = this.status1[0]
          } else if (str == 130 || str == 140 || str == 150) {
            status = this.status1[1]
          } else if (str == 110) {
            status = this.status1[3]
          } else if (str == 160 || str == 180) {
            status = this.status1[2]
          }
        } else if(this.$route.name == 'mainPaseCmdcenter'){ //指挥中心
          if (str == '100') {
            status = this.status2[0]
          } else if (str == '120') {
            status = this.status2[1]
          } else if (str == '130') {
            status = this.status2[2]
          } else if (str == '140') {
            status = this.status2[3]
          } else if (str == '150') {
            status = this.status2[4]
          } else if (str == '160') {
            status = this.status2[5]
          } else if (str == '180') {
            status = this.status2[6]
          } else if (str == '190') {
            status = this.status2[7]
          } else if (str == '110') {
            status = this.status2[8]
          }else if(str == '114'){
            status = this.status2[9]
          }else if(str == '115'){
            status = this.status2[10]
          }else if(str == '210'){
            status = this.status2[11]
          }else if(str == '211'){
            status = this.status2[12]
          }else if(str == '230'){
            status = this.status2[13]
          }
        }else if(this.$route.name == 'mainPaseRranch'){
          if(str == '114'){
            status = this.status3[0]
          }else if(str == '115'){
            status = this.status3[1]
          }else if(str == '210'){
            status = this.status3[2]
          }else if(str == '211'){
            status = this.status3[3]
          }else if(str == '230'){
            status = this.status3[4]
          }
        }
        return status
      },
      lookinf(tid, caseState, solutionState, childId,subRegulatorId,regulatorId) {
        console.log(this.$route.name);
        console.log(caseState)
        if (this.$route.name == 'mainPase') {
          var routerName = "Par";
          if ((caseState == 140 && solutionState != 0) || caseState == 150 || caseState == 160) {
            routerName = "lookinf";
          }
          if (caseState == 180) {
            routerName = "resstep";
          }
          if (caseState == 110) {
            routerName = "FinishPar1";
          }
        } else if (this.$route.name == 'mainPaseRegulator') {
          var routerName = "RegPar";
          if (caseState == 130 || caseState == 140) {
            routerName = "Regresstep";
          }
          if (caseState == 180 || caseState == 160) {
            routerName = "resstepGoing";
          }
          if (caseState == 150) {
            routerName = "Reglookinf";
          }
          if (caseState == 110) {
            routerName = "RegFinishPar2";
          }
        } else  if(this.$route.name == 'mainPaseCmdcenter'){
          if(this.nowCaseItem.typeId != 900) {
            this.$router.push({
                  path: '/cmd_center/caseDetails',
                  query: {
                    caseid: this.detailsId,
                    index:this.activeIndex,
                    subRegulatorId:subRegulatorId,
                    regulatorId:regulatorId
                  },
                });
          }else {
            this.$router.push({
                  path: '/cmd_center/createDetails',
                  query: {
                    caseid: this.detailsId,
                    index:this.activeIndex,
                    subRegulatorId:subRegulatorId,
                    regulatorId:regulatorId
                  },
                });
          }
        
                
          // userlist_regulator({token:JSON.parse(window.localStorage.getItem("data")).data,regulatorId:regulatorId}).then((res)=>{
          //    console.log(res.data.obj)
          //  for(var i = 0 ;i <res.data.obj.length; i++) {
          //   console.log(subRegulatorId)
          //   if(res.data.obj[i].id == subRegulatorId) {
          //     this.$router.push({
          //         path: '/cmd_center/caseDetails',
          //         query: {
          //           caseid: this.detailsId,
          //           index:this.activeIndex,
          //           subRegulatorIdname:res.data.obj[i].name
          //         },
          //       });
          //   }
          //  }
          // })
        
          return
          var routerName = "ComOffer";
          if (caseState == 100) {
            routerName = "helpStart";
          }
          if (caseState == 110) {
            routerName = "finishEnd";
            this.$router.push({
              name: routerName,
              params: {
                token: this.token
              },
            });
            return
          }
          if (caseState == 120) {
            routerName = "ComParinf";
          }
          if (caseState == 180) {
            routerName = "Comresstep";
          }
          if (caseState == 190) {
            routerName = "Comresstep";
            this.$router.push({
              name: routerName,
              params: {
                token: this.token
              },
              query: {
                typeId: tid,
                caseid: childId,
                type: this.$route.query.type,
                sure: 1
              }
            });
            return
          }
          if (caseState == 210 || caseState == 211 || caseState == 230) {//分公司审核中
             routerName = "caserecord";
          }
        }else if(this.$route.name == 'mainPaseRranch'){//分支机构
            if (caseState == 210) {//分公司审核中
              if(this.insti.type == 4){
                routerName = "shenhezhongList";
              }else{
                routerName = "caserecord";
              }
            }else if(caseState == 230){//
              routerName = "underway";
            }else if(caseState == 110){
              routerName = "starcompleted";
            }else if(caseState == 211){//总公司审核中
              if(this.insti.type == 4){
                routerName = "underway";
              }else{
                routerName = "shenhezhongList";
              }
            }
        }
        this.$router.push({
          name: routerName,
          params: {
            token: this.token
          },
          query: {
            typeId: tid,
            caseid: childId,
            type: this.$route.query.type
          }
        });

      },
      openWork() {
        this.$store.commit('workData', this.nowCaseItem);
        this.$store.commit('workBtnFun', true);
      },
      addJb(){

      },
      aboutCase() {
        var data = {
          token: this.token,
          caseId: this.nowCaseItem.id
        };
        connectedCaseList(data)
          .then(res => {
            console.log(res);
            this.tableData = res.data.obj;
          })
          .catch(err => {
            console.log(err);
          });
      },
      addbrief(){
        console.log(this.nowCaseItem);
        if(!this.jbTitle) return this.$message.error('回访内容不能为空')
        // if(!this.uploadIdText) return this.$message.error('简报描述不能为空')
        var data={
          token:this.token,
          title:this.jbTitle,
          incidentId:this.nowCaseItem.id,
          detail:this.uploadIdText,
          uploadIds:this.valueSelect
        }
        addbrief(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('添加成功')
            this.centerDialogVisible2=false;
            this.$parent.getCompleteCase()
            this.$parent.getnowCase()
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
			//上传
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			beforeAvatarUpload(file) {
				const isLt8M = file.size / 1024 / 1024 < 8;
				if (!isLt8M) {
					this.$message.error('上传头像图片大小不能超过 8MB!');
				}
				return isLt8M;
			},
      requestFile(param) {
      	this.uploadBtn=true;
      	var fileObj = param.file
      	let config = {
      		headers: {
      			"Content-Type": "multipart/form-data"
      		}
      	};
      	var form = new FormData() // FormData 对象
      	var token = JSON.parse(window.localStorage.getItem("data")).data
      	form.append('file', fileObj) // 文件对象
      	form.append('token', token) // 文件对象
      	axios.post(SEVSRS + 'rescue/case/upload_file', form, config)
      		.then(res => {
      			if (res.data.code == 0) {
      				this.fileUrl.push(res.data.obj);
      				this.uploadBtn=false;
      			}
      		})
      		.catch(err => {
      			console.log(err)
      		})
      },
      uploadFileFun(){
        var arr=[]
        this.fileUrl.forEach(item => {
          var obj={
            description:this.description,
            objType:100,
            extra:`{from:${this.descriptionFrom},to:${this.descriptionTo}}`,
            type:this.nowCaseItem.caseState,
            objId:this.nowCaseItem.id,
            url:item
          }
          arr.push(obj)
        })
        var data={
            token:this.token,
            caseId:this.nowCaseItem.id,
            tUploadCnts:JSON.stringify(arr)
        }
        uploadFile(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('添加成功')
            this.centerDialogVisible3=false;
            this.$parent.getnowCase()
            this.$parent.getCompleteCase()
          }
        })
        .catch(err => {
          console.log(res);
        })
      },
      zrrd(){
        console.log(this.nowCaseItem);
        noticeAccessCaseLiability({token:this.token,id:this.nowCaseItem.id})
        .then(res => {
          if(res.data.code == 0){
            this.$message.success('提醒成功')
          }
        })
        .catch(err => {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped="scoped">
  .casemainBox {
    border: 1px solid #eee;
    border-radius: 5px;
    box-shadow: 4px 8px 10px rgba(0, 171, 250, 0.1);
    background-color: white;
    margin-bottom: 40px;
    position: relative;
    overflow: hidden;
  }
  .casemainBox .title{
    width: 120px;
    height: 80px;
    background-color: #f9dc40;
    text-align: center;
    color: #c47809;
    border-radius: 50%;
    line-height: 100px;
    position: absolute;
    top: -30px;
    left: 50%;
    margin-left: -60px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .caseBox {
    padding: 40px;
    position: relative;
    overflow: hidden;
    padding-top: 60px;
  }

  .caseBox .yuan {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #00abfa;
    color: #fff;
    font-size: 14px;
    line-height: 25px;
    text-align: center;
    margin-top: 5px;
  }

  .caseBox .top {
    overflow: hidden;
  }

  .caseBox .top li {
    float: left;
    font-size: 16px;
    line-height: 40px;
  }

  .caseBox .top .left {
    float: left;
    overflow: hidden;
  }

  .caseBox .top .left li {
    margin-left: 25px;
  }

  .caseBox .top .right {
    float: right;
    overflow: hidden;
  }

  .caseBox .top .right li {
    margin-right: 25px;
  }

  .caseBox .top .text1 {
    color: #ff7200;
  }

  .caseBox .top .btn {
    height: 40px;
    line-height: 40px;
    display: block;
    background-color: #00abfa;
    color: white;
    text-align: center;
    cursor: pointer;
    padding: 0 20px;
    border-radius: 5px;
  }

  .table1 {
    margin-top: 20px;
  }

  .table1 th {
    height: 40px;
    color: #444;
  }

  .table td {
    text-align: center;
    color: #999;
    height: 65px;
    border-bottom: 1px solid #eee;
  }

  .table table {
    border: 1px solid #eee;
  }

  .table {
    height: 197px;
    overflow-y: auto;
  }

  .text2 {
    font-size: 18px;
    margin-left: 50px;
  }

  .text2 span {
    color: #ff7200;
  }

  .btnWorkbench {
    overflow: hidden;
    margin-top: -30px;
    border: 1px solid #f5ebb5;
    background: #fffce9;
    padding: 20px 10px;
  }

  .btnWorkbench button {
    border: 5px solid #f8dc40;
    height: 45px;
    padding: 0 20px;
    background: #fbea8c;
    border-radius: 5px;
    color: #c27506;
    cursor: pointer;
    outline: none;
  }

  .btnWorkbench button:first-child {
    float: left;
    margin-left: 60px;
  }

  .btnWorkbench>div {
    float: right;
    margin-right: 20px;
  }

  .btnWorkbench>div button {
    margin-left: 60px;
  }

  .aboutCase li {
    border-bottom: 1px solid #d9d9d9;
    padding: 15px 0;
    overflow: hidden;
    cursor: pointer;
  }

  .aboutCase li:first-child {
    border-top: 1px solid #d9d9d9;
  }

  .aboutCase li span {
    float: left;
  }

  .aboutCase li i {
    float: right;
    font-size: 20px;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
  .popBtn{display: block;margin: 0 auto;margin-top: 10px;}
  .jianbao >div{margin-bottom: 10px;}
  .jianbao div *{vertical-align:middle;}
  .jianbao span{display: inline-block;width: 80px;text-align: right;}
  .fujian span{vertical-align: top;}
  .moreCase ul{width: 100%; overflow: hidden;margin: 20px 0;}
  .moreCase li{float: left;width: 150px;background-image: url(img/2.png);background-position: left top;background-repeat: no-repeat;background-size: 100% 100%;height: 35px;padding: 0 10px;line-height: 35px;text-align: center;color: #05aaf9;cursor: pointer;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;margin-bottom: 10px;}
  .moreCase li.redBack{background-image: url(img/3.png);color:#fff}
  .moreCase li.active{background-image: url(img/1.png);color: #fff;}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/case.vue